import { createSelector } from 'reselect';

const trainingCenterState = (state) => state.trainingCenterReducer;

export const trainingCenterList = createSelector(
  [trainingCenterState],
  (ts) => ts.items
);
const selectById = (state, itemId) => itemId;

export const trainingCenterAsListAndValue = createSelector(
  [trainingCenterList],
  (ts) =>
    ts.map(({ _id, businessName, status, businessNamei18n }) => ({
      businessName,
      _id,
      status,
      businessNamei18n
    }))
);

export const trainingCenterByIdSelectro = createSelector(
  [trainingCenterList],
  (trainingCenters, _id) => {
    const trainingCenter = trainingCenters.find((item) => _id === item._id);
    // console.log('tt', trainingCenters);
    if (!trainingCenter) return null;
    return trainingCenter;
  }
);

export const currentTrainingCenter = createSelector(
  [trainingCenterState],
  (ts) => ts.currentTrainigCenter
);

export const currentTrainingCenterCourses = createSelector(
  [currentTrainingCenter],
  (course) => course?.courses
);

export const currnetTrainingCenterCourseById = createSelector(
  [currentTrainingCenterCourses, selectById],
  (cs, _id) => {
    console.log('cs,', _id);
    const course = cs?.find((item) => _id === item._id);
    if (!course) return null;
    return course;
  }
);

// export const currentTrainingCenterCoursesCount = createSelector(
//   [currentTrainingCenter],
//   (course) => course?.courses.length
// );

export const trainingCenterCount = createSelector(
  [trainingCenterState],
  (ts) => ts.count
);

export const trainingCenterLoading = createSelector(
  [trainingCenterState],
  (ts) => ts.isLoading
);

export const trainingCenterSearchValue = createSelector(
  [trainingCenterState],
  (ts) => ts.searchValue
);
